module.exports = {
  element: "div",
  className: "loader2Container",
  children: [
    {
      element: "div",
      className: "loaderBlock1 loaderBlock",
    },
    {
      element: "div",
      className: "loaderBlock3 loaderBlock",
    },
    {
      element: "div",
      className: "loaderBlock2 loaderBlock",
    },
    {
      element: "div",
      className: "loaderBlockIcon loaderBlock",
    },
  ],
};
